<template>
  <b-modal
    :visible="showModal"
    title="Cadastrar Regra de Plantão"
    @hide="$emit('close')"
    hide-footer
  >
    <b-form @submit.prevent="salvar">
      <!-- 📌 Dados do Plantão -->
      <div class="form-section border-primary bg-light-blue">
        <h6 class="mb-3">📌 Dados do Plantão</h6>
        <b-form-group label="Tipo de Plantão:">
          <b-form-select v-model="regra.tipo" :options="opcoesTipoPlantao" required />
        </b-form-group>

        <b-form-group label="Médico:">
          <b-form-input
            v-model="regra.medico"
            @input="buscarMedicos"
            placeholder="Digite o nome do médico"
            autocomplete="off"
            required
          />
          <div class="position-relative">
            <b-list-group
              v-if="medicosFiltrados.length && regra.medico"
              class="autocomplete-dropdown position-absolute w-100 z-index"
            >
              <b-list-group-item
                v-for="(item, index) in medicosFiltrados"
                :key="index"
                @click="selecionarMedico(item)"
                class="autocomplete-item"
              >
                {{ item }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-form-group>
      </div>

      <!-- ⏰ Horários -->
      <div class="form-section border-secondary bg-light-gray">
        <h6 class="mb-3">⏰ Horários</h6>
        <b-row class="pl-2 pr-2">
          <b-col>
            <b-form-group label="Início (HH:mm):">
              <b-form-input v-model="regra.inicio" type="time" required />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Duração (HH:mm):">
              <b-form-input v-model="regra.duracao" type="time" required />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- ⚙️ Configuração da Escala -->
      <div class="form-section border-success bg-light-green">
        <h6 class="mb-3">⚙️ Configuração da Escala</h6>
        <b-form-group label="Tipo de Escala:">
          <b-form-select v-model="regra.tipoEscala" :options="opcoesTipoEscala" required />
        </b-form-group>

        <b-row class="pl-2 pr-2" v-if="regra.tipoEscala === 'Trabalho x Descanso'">
          <b-col>
            <b-form-group label="Tipo de Intervalo:">
              <b-form-select v-model="regra.tipoIntervalo" :options="opcoesTipoIntervalo" required />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Intervalo (valor numérico):">
              <b-form-input v-model="regra.intervalo" type="number" min="1" required />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group v-if="regra.tipoEscala === 'Semanal'" label="Dias da Semana:">
          <b-form-checkbox-group
            v-model="regra.diasSemana"
            :options="opcoesDiasSemana"
            :value-field="'key'"
            :text-field="'label'"
          />
        </b-form-group>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between align-items-center">
        <b-button
          variant="danger"
          v-if="regra.semanaIndex !== null && regra.dayKey && regra.plantaoIndex !== null"
          @click="removerPlantao"
        >
          Remover
        </b-button>
        <div class="ml-auto">
          <b-button variant="secondary" @click="$emit('close')">Cancelar</b-button>
          <b-button variant="primary" type="submit">Salvar</b-button>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  props: ['showModal', 'regraEdicao'],
  data() {
    return {
      regra: this.regraEdicao ? { ...this.regraEdicao } : {
        tipo: '',
        medico: '',
        inicio: '',
        duracao: '',
        tipoEscala: '',
        tipoIntervalo: '',
        intervalo: 1,
        diasSemana: [],
        semanaIndex: null,
        dayKey: null,
        plantaoIndex: null
      },
      opcoesTipoPlantao: ['Normal', 'Sobreaviso', 'Extra'],
      opcoesTipoEscala: ['Trabalho x Descanso', 'Semanal'],
      opcoesTipoIntervalo: ['Hora', 'Dia', 'Semana', 'Mês'],
      opcoesDiasSemana: [
        { key: 'seg', label: 'Seg' },
        { key: 'ter', label: 'Ter' },
        { key: 'qua', label: 'Qua' },
        { key: 'qui', label: 'Qui' },
        { key: 'sex', label: 'Sex' },
        { key: 'sab', label: 'Sáb' },
        { key: 'dom', label: 'Dom' }
      ],
      listaMedicos: [
        'Ana Costa', 'Bruno Silva', 'Carlos Oliveira',
        'Daniela Souza', 'Eduardo Lima', 'Fernanda Rocha'
      ]
    }
  },
  computed: {
    medicosFiltrados() {
      const termo = (this.regra.medico || '').toLowerCase()
      return this.listaMedicos.filter(m => m.toLowerCase().includes(termo) && m !== this.regra.medico)
    }
  },
  methods: {
    buscarMedicos() {},
    selecionarMedico(nome) {
      this.regra.medico = nome
    },
    salvar() {
      this.$emit('salvar-regra', { ...this.regra })
    },
    removerPlantao() {
      this.$emit('salvar-regra', { ...this.regra, remover: true })
    }
  },
  watch: {
    regraEdicao(newVal) {
      if (newVal) this.regra = { ...newVal }
    }
  }
}
</script>

<style scoped>
.form-section {
  border-left: 5px solid;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}
.bg-light-blue {
  background-color: #e8f4fd;
}
.bg-light-gray {
  background-color: #f3f4f6;
}
.bg-light-green {
  background-color: #e6f5ec;
}
.autocomplete-dropdown {
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.z-index {
  z-index: 9999;
}
.autocomplete-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.autocomplete-item:hover {
  background-color: #e2f0ff;
  font-weight: 500;
}
</style>
